import { render, staticRenderFns } from "./ReplaceTextModal.vue?vue&type=template&id=d90a74b6"
import script from "./ReplaceTextModal.vue?vue&type=script&lang=js"
export * from "./ReplaceTextModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports